'use client';

import {
  GraduationCap,
  FileBadge2,
  Presentation,
  Wallet2,
  PiggyBank,
  TrendingUp,
} from "lucide-react";

const HIGHLIGHTS = [
  {
    id: 1,
    icon: GraduationCap,
    title: "Degree/Diploma from MSU",
    description:
      "Degree/diploma from Medhavi Skills University on successful course completion.",
  },
  {
    id: 2,
    icon: FileBadge2,
    title: "Joint Certification",
    description:
      "Joint certification from industry/NCVET on successful course completion.",
  },
  {
    id: 3,
    icon: Presentation,
    title: "On-the-Job Training at Industry",
    description:
      "Practical skills through on-the-job training at industry after theoretical learning.",
  },
  {
    id: 4,
    icon: Wallet2,
    title: "Learn and Earn",
    description:
      "Monthly stipend under the ‘learn and earn’ scheme provided by WISE.",
  },
  {
    id: 5,
    icon: PiggyBank,
    title: "Attractive Salary Prospects",
    description:
      "Career growth with attractive salary prospects and rewarding opportunities.",
  },
  {
    id: 6,
    icon: TrendingUp,
    title: "Employment Readiness",
    description:
      "Employment readiness with skill-based training and real-world experience.",
  },
];

export function WiseHighlightsSection() {
  return (
    <section className="relative bg-[#0078A6] py-12 md:py-16 lg:py-20 text-white">
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        {/* Heading */}
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight">
            The WISE Highlights
          </h2>
          <p className="mt-2 text-sm md:text-base text-sky-50/90 max-w-2xl mx-auto">
            Here&apos;s how WISE equips students with career-ready skills through
            work-integrated education.
          </p>
        </div>

        {/* Cards */}
        <div className="grid gap-4 md:gap-5 lg:gap-6 md:grid-cols-2 mb-8 md:mb-10">
          {HIGHLIGHTS.map((item) => (
            <HighlightCard key={item.id} {...item} />
          ))}
        </div>

        {/* CTA */}
        {/* <div className="text-center">
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-full bg-[#F5A700] px-8 md:px-10 py-3 md:py-3.5 text-sm md:text-base font-semibold text-slate-950 shadow-[0_14px_30px_rgba(0,0,0,0.35)] hover:bg-[#ffb61c] transition transform hover:-translate-y-0.5"
          >
            Partner With Us
          </button>
        </div> */}
      </div>
    </section>
  );
}

function HighlightCard({ icon: Icon, title, description }) {
  return (
    <div className="rounded-[26px] bg-[#0086B9]/95 border border-white/10 shadow-[0_14px_36px_rgba(0,0,0,0.22)] px-5 py-5 md:px-7 md:py-6 flex items-stretch gap-4 md:gap-5">
      {/* Icon */}
      <div className="flex-shrink-0">
        <div className="h-16 w-16 md:h-18 md:w-18 rounded-2xl bg-white flex items-center justify-center shadow-md">
          <Icon className="h-8 w-8 text-[#0086B9]" />
        </div>
      </div>

      {/* Text */}
      <div className="flex-1">
        <h3 className="text-base md:text-lg font-semibold mb-1.5">
          {title}
        </h3>
        <p className="text-xs md:text-sm text-sky-50/90 leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}
